import { render, staticRenderFns } from "./FirmaLink.vue?vue&type=template&id=f0c08ba2&scoped=true"
import script from "./FirmaLink.vue?vue&type=script&lang=js"
export * from "./FirmaLink.vue?vue&type=script&lang=js"
import style0 from "./FirmaLink.vue?vue&type=style&index=0&id=f0c08ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c08ba2",
  null
  
)

export default component.exports